

<ng-template #clientStatementGridRef>
  @if (gridName) {
      <page-grid [gridConfig]="clientStatementGrid" (gridClickColumn)="openDialog($event)" />
  } @else {
      <h3>No Client Statement found</h3>
  }
</ng-template>

@if(data) {
  <modal-panel
    [title]="'Client Statement'"
    (close)="closeModal()"
    data-testid="client-statement-modal-panel">
    
    <ng-container [ngTemplateOutlet]="clientStatementGridRef"></ng-container>

    <ng-container modalPanelFooter data-testid="client-statement-modal-panel-footer">
      <button mat-button mat-raised-button color="primary" (click)="closeModal()" data-testid="client-statement-modal-panel-close-button">Close</button>
    </ng-container>
    
  </modal-panel>
} @else {
  <ng-container [ngTemplateOutlet]="clientStatementGridRef"></ng-container>
}
